import * as React from 'react';

import { useAtomValue } from 'jotai';

import { translate } from '~l10n/client';
import { Dialog } from '~shared/components/Dialog';
import {
  CurrentQuizEditorDialog,
  currentQuizEditorDialogAtom,
} from '~teacher/components/QuizEditor/atoms/currentQuizEditorDialogAtom';
import { useQuizContext } from '~teacher/components/QuizEditor/contexts/QuizContextProvider';
import { HideIntercomLauncher } from '~teacher/hook/utils/HideIntercomLauncher';

import { extractQuestionsPositionAtom } from './atoms';
import { ExtractQuestions } from './ExtractQuestions';

interface Props {
  onClose: () => void;
}

export function ExtractQuestionsDialog({ onClose }: Props) {
  const currentQuizEditorDialog = useAtomValue(currentQuizEditorDialogAtom);

  const isOpen =
    currentQuizEditorDialog === CurrentQuizEditorDialog.ExtractQuestionsFromDoc;

  const { quizId, workspaceQuizId, workspaceId } = useQuizContext();
  const position = useAtomValue(extractQuestionsPositionAtom);

  return (
    <Dialog
      position="right"
      showBackdrop={false}
      open={isOpen}
      onClose={onClose}
      id="extract-questions-from-doc-dialog"
      size="medium"
      title={''}
      closeLabel={translate('Close')}
      disableBackdropClose
    >
      {isOpen && (
        <>
          <HideIntercomLauncher />
          <ExtractQuestions
            quizId={quizId}
            workspaceQuizId={workspaceQuizId}
            workspaceId={workspaceId}
            insertionOrder={position}
          />
        </>
      )}
    </Dialog>
  );
}
